export {
  default as CommunicationsPreferencesForm,
  CommunicationsPreferencesFormProps,
} from "./communicationsPreferencesForm";
